type Fetch = (input?: RequestInfo, init?: RequestInit) => Promise<any>;
type Configuration = {
  fetch: Fetch;
  refreshToken: () => Promise<void>;
  responseMap?: (response: Response) => any;
};

export function refreshFetch(configuration: Configuration): Fetch {
  const { fetch, responseMap } = configuration;

  const AuthError = new Error('Auth Error');

  return async (url: any, options: Object) => {
    let retries = 0;
    const request = () => {
      retries++;
      return fetch(url, options);
    };

    const result = await request()
      .then(async (response: Response | any) => {
        if (!isNaN(response?.status)) {
          if (response.status === 401 || response.status === 403) {
            throw AuthError;
          }
          if (responseMap) {
            return responseMap(response);
          }
          const contentType = response?.headers?.get('content-type');
          if (contentType && contentType.indexOf('json') !== -1) {
            return response.json();
          } else {
            return response.text();
          }
        } else {
          return response;
        }
      })
      .catch(async (error) => {
        if (error == AuthError && retries < 3) {
          const r = await request();

          console.log('new request', r);
          return r;
        }
        return Promise.reject(error);
      });

    return result;
  };
}
